/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_ArchivedInputs */

const en_user_archived = /** @type {(inputs: User_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived`)
};

const ja_user_archived = /** @type {(inputs: User_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブ済`)
};

const fr_user_archived = /** @type {(inputs: User_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivé`)
};

const de_user_archived = /** @type {(inputs: User_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviert`)
};

/**
* | output |
* | --- |
* | "Archived" |
*
* @param {User_ArchivedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_archived = /** @type {((inputs?: User_ArchivedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_ArchivedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_archived(inputs)
	if (locale === "ja") return ja_user_archived(inputs)
	if (locale === "fr") return fr_user_archived(inputs)
	return de_user_archived(inputs)
});